( function($) {

	var app = {

		initFormatNumber: function(){
			var $phoneNumber = $('.ip-contact-content-btn.is-phone a i').text();
			var $cleanedNumber = $phoneNumber.replace(/[^\d+]/g, '');
			var $formattedNumber = $cleanedNumber.replace(/\+(\d{1})(\d{3})(\d{3})(\d{4})/, 'tel:+$1.$2.$3.$4');
			$('.ip-contact-content-btn.is-phone a').attr('href', $formattedNumber);
		},
	}

	
	$(document).ready( function() {
		app.initFormatNumber();
	});
	
	$(window).on('load', function(){

	});

})(jQuery);